import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, orientacoes_penalidades } from '../../../settings';
import { DelayLink, SliderText, CardAccordion, CardAccordionHeader, CardAccordionBody } from '../../../components';

import '../Iniciativas.scss';
import './BalancoOrientacoesPenalidades.scss';

class BalancoOrientacoesPenalidades extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Balanço das orientações e penalidades da autorregulação - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home balanco-orientacoes-penalidades-home page-gradient page-gradient--yellow bg-gray"
          ref="balanco-orientacoes-penalidades-home"
        >
          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--yellow`}>
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to={`/estrategias/para-o-mercado`}
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">
                            Balanço das orientações e <br className="br_desk" />
                            penalidades da autorregulação
                          </h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Estamos sempre supervisionando o cumprimento das normas da autorregulação pelas instituições
                            financeiras. Essa atuação é prioritariamente educativa, ou seja, foca na orientação antes de
                            ser utilizada qualquer penalidade. Quando há aplicação de multas, os recursos recebidos são
                            totalmente investidos em iniciativas de educação – sejam para as instituições, para os
                            profissionais do mercado ou para os investidores.
                          </p>
                        </div>
                      </div>

                      {/* <div className="card__image">
												<img src={content.image} />
											</div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <CardAccordion
                      noBorder
                      color="yellow"
                      header={
                        <CardAccordionHeader>
                          <h2 className="title">Entenda cada tipo de orientação e penalidade </h2>
                        </CardAccordionHeader>
                      }
                      content={
                        <CardAccordionBody>
                          <SliderText items={orientacoes_penalidades.items} color={'yellow'} />
                        </CardAccordionBody>
                      }
                    />
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--no-border card--horas card--secondary">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <h3 className="title title--small yellow">Confira os resultados de 2019</h3>
                          <p>
                            Os pedidos de esclarecimento mais que dobraram em 2019 na comparação com o ano anterior –
                            foram 5.108 frente a 1.898 – assim como as cartas de orientação – que somaram 1.286 diante
                            de 548 na mesma base de comparação. Grande parte desse crescimento se deu no Código de
                            Certificação por conta de termos intensificado o trabalho de regularização. Os
                            monitoramentos envolveram a checagem das certificações necessárias de acordo com as
                            atividades de cada profissional, os pedidos de isenção da CGA, a fiscalização da CGA em
                            casas de gestão, entre outros.
                          </p>
                          <p>
                            As multas também chamaram atenção no ano, chegando a 1.017, grande parte aplicada às
                            instituições que seguem o Código de Administração de Recursos de Terceiros. A maioria das
                            penalidades se deu por ausência ou atraso no envio de informações de valor de patrimônio
                            líquido e cota de fundos de investimento para a base de dados.
                          </p>
                          <p>
                            Para conferir o detalhamento de todas as orientações e penalidades aplicadas no ano, confira
                            o{' '}
                            <a
                              href="https://www.anbima.com.br/pt_br/autorregular/supervisao/informes/relatorio-de-supervisao.htm"
                              target="_blank"
                              className="text_link text_link--yellow"
                            >
                              Relatório de Supervisão
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <table className="table table--yellow table--custom" cellPadding={0} cellSpacing={0}>
                      <thead>
                        <tr>
                          <th>
                            <small>Balanço de orientações e penalidades nos últimos três anos</small>
                          </th>
                          <th width="65">2019</th>
                          <th width="65">2018</th>
                          <th width="65">2017</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Cartas de orientação</td>
                          <td>1.286</td>
                          <td>548</td>
                          <td>339</td>
                        </tr>

                        <tr>
                          <td>Cartas de recomendação</td>
                          <td>1</td>
                          <td>1</td>
                          <td>1</td>
                        </tr>

                        <tr>
                          <td>Julgamentos</td>
                          <td>5</td>
                          <td>7</td>
                          <td>7</td>
                        </tr>

                        <tr>
                          <td>Multas</td>
                          <td>1.017</td>
                          <td>656</td>
                          <td>445</td>
                        </tr>

                        <tr>
                          <td>PAIs</td>
                          <td>25</td>
                          <td>15</td>
                          <td>19</td>
                        </tr>

                        <tr>
                          <td>Pedidos de esclarecimento</td>
                          <td>5.108</td>
                          <td>1.898</td>
                          <td>1.600</td>
                        </tr>

                        <tr>
                          <td>Processos</td>
                          <td>12</td>
                          <td>6</td>
                          <td>28</td>
                        </tr>

                        <tr>
                          <td>Termos de compromisso</td>
                          <td>21</td>
                          <td>14</td>
                          <td>24</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>Total</td>
                          <td>7.475</td>
                          <td>3.145</td>
                          <td>2.463</td>
                        </tr>
                      </tfoot>
                    </table>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="card card--no-border card--final">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <h3 className="title title--small yellow">Novas adesões</h3>

                          <p>
                            No ano, 133 instituições começarem a seguir as regras dos nossos códigos de autorregulação.
                            Muitas delas se tornaram aderentes às normas de mais <br className="br_desk" />
                            de um documento. Confira:
                          </p>

                          <div className="final_legenda">
                            <div className="final_legenda__item final_legenda__item--dark">
                              <div className="icon"></div>
                              <span>Código</span>
                            </div>
                            <div className="final_legenda__item final_legenda__item--yellow">
                              <div className="icon"></div>
                              <span>Número de adesões*</span>
                            </div>
                          </div>

                          <div className="final_data">
                            <div className="columns row">
                              <div className="col">
                                <h3>74</h3>
                                <p>
                                  Administração
                                  <br />
                                  de Recursos
                                  <br />
                                  de Terceiros
                                </p>
                              </div>
                              <div className="col">
                                <h3>75</h3>
                                <p>Certificação</p>
                              </div>
                              <div className="col">
                                <h3>11</h3>
                                <p>Distribuição</p>
                              </div>
                              <div className="col">
                                <h3>40</h3>
                                <p>FIP e FIEE</p>
                              </div>
                              <div className="col">
                                <h3>4</h3>
                                <p>Negociação</p>
                              </div>
                              <div className="col">
                                <h3>4</h3>
                                <p>
                                  Ofertas
                                  <br />
                                  Públicas
                                </p>
                              </div>
                              <div className="col">
                                <h3>11</h3>
                                <p>
                                  Serviços
                                  <br />
                                  Qualificados
                                </p>
                              </div>
                            </div>

                            <hr></hr>
                          </div>

                          <div className="final_total">
                            <p className="text-center total_value">
                              Total*: <strong className="yellow">219</strong>
                            </p>
                          </div>

                          <hr />
                          <p className="light-gray">
                            <b>*</b> Há instituições que começaram a seguir as regras de mais de um código. Por isso, o
                            total de adesões é maior que o número de novas empresas na autorregulação.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                {/* <div className="col-6">
									<Fade bottom>

										<table className="table table--yellow table--custom2" cellPadding={0} cellSpacing={0}>
											<thead>
												<tr>
													<th>Código </th>
													<th width="195">Número de adesões*</th>
												</tr>
											</thead>

											<tbody>
												<tr>
													<td>FIP e FIEE</td>
													<td>40</td>
												</tr>
												<tr>
													<td>Administração de Recursos de Terceiros </td>
													<td>74</td>
												</tr>
												<tr>
													<td>Distribuição</td>
													<td>11</td>
												</tr>
												<tr>
													<td>Negociação</td>
													<td>4</td>
												</tr>
												<tr>
													<td>Certificação</td>
													<td>75</td>
												</tr>
												<tr>
													<td>Ofertas Públicas</td>
													<td>4</td>
												</tr>
												<tr>
													<td>Serviços Qualificados</td>
													<td>11</td>
												</tr>

											</tbody>
											<tfoot>
												<tr>
													<td>Total*</td>
													<td>219</td>
												</tr>
											</tfoot>
										</table>

									</Fade>
								</div> */}
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { BalancoOrientacoesPenalidades };
